import type { ReactNode } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router';
import { useSession, useUser } from '../auth/session';
import { LegalLinks } from './LegalLinks';

function Brand() {
  return (
    <span className="brand">
      <img src="/favicon.svg" alt="" width="28" height="28" />
      Couch
    </span>
  );
}

/** The frame of every signed-in page. */
export function Layout() {
  const user = useUser();
  const { signOut } = useSession();
  const navigate = useNavigate();
  const onSignOut = () => { void signOut().then(() => { void navigate('/login', { replace: true }); }); };
  return (
    <div className="shell">
      <header className="topbar">
        <Brand />
        <nav aria-label="Main">
          <NavLink to="/" end>My machines</NavLink>
          <NavLink to="/workflows">Workflows</NavLink>
          <NavLink to="/claude">Claude</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/library">Library</NavLink>
          <NavLink to="/knowledge">Knowledge</NavLink>
          <NavLink to="/connections">Connections</NavLink>
          <NavLink to="/about">About</NavLink>
          {user.role === 'owner' && <NavLink to="/admin">Admin</NavLink>}
          <NavLink to="/account">Account</NavLink>
        </nav>
        <button type="button" className="button-quiet" onClick={onSignOut}>Sign out</button>
      </header>
      <main className="content">
        <Outlet />
      </main>
      <LegalLinks />
    </div>
  );
}

/** The centred card used by the signed-out pages. */
export function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="auth">
      <div className="auth-card">
        <Brand />
        <h1>{title}</h1>
        {children}
      </div>
      <LegalLinks />
    </main>
  );
}
